import React from 'react'

const bannerAPI = {
    homepage:[
        {
            heading:"Find Your Preferred Courses",
            paragraph:"Build skills with courses, certificates and degree online from world-class universities and companies",
            img:"./assets/images/Homepage/banner/MuktarAhmed.png",
            imgmb:"./assets/images/Mobile/HomepageMb/banner/teacherpicforbanner.png"
        },
        {
            heading:"Quranic Arabic Blended Professional",
            paragraph:"Build skills with courses, certificates and degree online from world-class universities and companies",
            img:"./assets/images/Homepage/banner/bannerslider2.png",
            imgmb:"./assets/images/Mobile/HomepageMb/banner/teacherpicforbanner.png"
        },
       
    ],
    aboutuspage:[
        {
            heading:"Hi, I'm Professor MOKHTER AHMAD",
            paragraph:"TARBIYAH INSTITUTE is established a clear path for success in this life and the Hereafter by understanding with the aim to spread the Quran and Hadith.",
            img:"./assets/images/Homepage/banner/MuktarAhmed.png",
            imgmb:"./assets/images/Mobile/HomepageMb/banner/teacherpicforbanner.png"
        },
        {
            heading:"Quranic Arabic Blended Professional",
            paragraph:"Build skills with courses, certificates and degree online from world-class universities and companies",
            img:"./assets/images/Homepage/banner/bannerslider2.png",
            imgmb:"./assets/images/Mobile/HomepageMb/banner/teacherpicforbanner.png"
        },
    ]
}

const BannerAPI = () => {
  return (
    <>

    </>
  )
}

export {bannerAPI}

export default BannerAPI